import {Button} from "@mui/material";
import ChevronLeftIcon from "assets/icons/ChevronLeft";
import {MAIN_PAGE} from "constants/common";

const BackToMainPage = () => {
  return (
    <Button
      component={"a"}
      href={MAIN_PAGE}
      startIcon={<ChevronLeftIcon sx={{width: 20, height: 20}}/>}
      sx={(theme) => ({
      ...theme.typography.p3,
      backgroundColor: 'white',
      color: 'black.100',
      borderRadius: 3,
      px: 2,
      height: 40,
    })}>
      Вернуться на главную
    </Button>
  )
}

export default BackToMainPage
